export const SET_RESET_CODE = 'FORGOT_PASSWORD/SET_RESET_CODE'
export const SUBMIT = 'FORGOT_PASSWORD/SUBMIT'
export const SUBMIT_RESET = 'FORGOT_PASSWORD/SUBMIT_RESET'
